import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export type Role = 'SUPER_ADMIN' | 'ADMIN' | 'VIEWER' | 'CLIENT';
export type AccessLevel = 'TRADE' | 'VIEW_ONLY';
export interface AuthUser {
  id: number;
  role: Role;
  fullName: string;
  userType: 'ADMIN' | 'CLIENT';
  /** CLIENT trade permission; undefined for admins. VIEW_ONLY clients are read-only. */
  accessLevel?: AccessLevel;
}

interface AuthState {
  accessToken: string | null;
  user: AuthUser | null;
  /** False until the initial silent session-restore attempt has finished. */
  bootstrapped: boolean;
}

const initialState: AuthState = { accessToken: null, user: null, bootstrapped: false };

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    setCredentials(state, action: PayloadAction<{ accessToken: string; user: AuthUser }>) {
      state.accessToken = action.payload.accessToken;
      state.user = action.payload.user;
    },
    setAccessToken(state, action: PayloadAction<string>) {
      state.accessToken = action.payload;
    },
    logout(state) {
      state.accessToken = null;
      state.user = null;
    },
    setBootstrapped(state) {
      state.bootstrapped = true;
    },
  },
});

export const { setCredentials, setAccessToken, logout, setBootstrapped } = authSlice.actions;
export default authSlice.reducer;
